import React, { useState, useEffect, useRef } from 'react';
import Header from '../components/Header';
import CustomFooter from '../components/Footer';
import { fetchMessages, fetchOlderMessages, accept_or_reject_new_team_member, clear_message, accept_or_reject_coach_invite } from '../api/messages';
import { FaEnvelopeOpenText, FaUserCircle } from 'react-icons/fa';
import { useParams } from 'react-router-dom';

const ViewMessages = () => {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");
    const [loadingOlder, setLoadingOlder] = useState(false);
    const [scrollToBottom, setScrollToBottom] = useState(true);
    const { username } = useParams();
    const messagesEndRef = useRef(null);
    const messagesContainerRef = useRef(null);
    const textareaRef = useRef(null);

    useEffect(() => {
        const getMessages = async (username) => {
            try {
                const response = await fetchMessages(username);
                setMessages(response.data);
            } catch (error) {
                console.error("Error fetching messages:", error);
            }
        };
        getMessages(username);
    }, [username]);

    useEffect(() => {
        if (scrollToBottom) {
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages, scrollToBottom]);

    const handleSendMessage = () => {
        if (newMessage.trim()) {
            const newMsg = { sender: "You", username: "your-username", content: newMessage, timestamp: new Date().toISOString() };
            setMessages([...messages, newMsg]);
            setNewMessage("");
            setScrollToBottom(true);
            textareaRef.current?.focus();
        }
        if(username === "system"){
            const newMsg = { sender: "System", username: "system", content: "System does not accept messages.", timestamp: new Date().toISOString() };
            setMessages([...messages, newMsg]);
            setNewMessage("");
            setScrollToBottom(true);
            textareaRef.current?.focus();
        }
    };

    const handleKeyDown = (e) => {
        const isMobile = /Mobi|Android/i.test(navigator.userAgent);
        if (!isMobile && e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    const loadOlderMessages = async () => {
        setLoadingOlder(true);
        try {
            const response = await fetchOlderMessages();
            if (response.data.length === 0 || response.data[0].timestamp === messages[0]?.timestamp) {
                alert("No more older messages");
            } else {
                setMessages((prevMessages) => [...response.data, ...prevMessages]);
            }
            setScrollToBottom(false);
        } catch (error) {
            console.error("Error fetching older messages:", error);
        } finally {
            setLoadingOlder(false);
        }
    };

    return (
        <div className="bg-gray-100 min-h-screen flex flex-col">
            <Header />
            <div className="container mx-auto p-6">
                <h2 className="text-2xl font-semibold mb-4">Chat with {username}</h2>
                <div ref={messagesContainerRef} className="bg-white rounded-lg shadow-md p-6 h-[500px] overflow-y-auto flex-grow relative">
                    <div className="w-full flex justify-center mb-2">
                        <button 
                            className={`w-full text-center py-2 rounded-lg ${loadingOlder ? 'bg-gray-400' : 'bg-gray-300'}`} 
                            onClick={loadOlderMessages} 
                            disabled={loadingOlder}
                        >
                            {loadingOlder ? "Loading..." : "Load Older Messages"}
                        </button>
                    </div>
                    {messages.length === 0 ? (
                        <p className="text-gray-600">No messages received.</p>
                    ) : (
                        <ul className="space-y-4">
                            {messages.map((message, index) => { 
                                if(username === "system" && message.identifier !== undefined){                                   
                                        return (
                                            <li 
                                                key={index} 
                                                className={`flex flex-col ${message.username === username ? 'items-start' : 'items-end'}`}
                                            >
                                                <div className="flex items-center mb-2">
                                                    <FaUserCircle className="text-blue-500 text-2xl mr-2" />
                                                    <span className="font-semibold">{message.sender}</span>
                                                </div>
                                                <div className={`flex items-center mb-2 ${message.username === username ? 'justify-start' : 'justify-end'}`}>
                                                    <FaEnvelopeOpenText className="text-blue-500 text-xl mr-2" />
                                                    <span className="text-gray-700 bg-gray-200 p-2 rounded-lg max-w-xs break-words">
                                                        {message.content}
                                                    </span>                              
                                                </div>
                                                <div className={`${message.type === 0 ? '' : 'hidden'} flex items-center mb-2 ${message.username === username ? 'justify-start' : 'justify-end'}`}>
                                                    <button
                                                        onClick={ async () => { 
                                                                const res = await accept_or_reject_new_team_member(message.identifier, 0);
                                                                if(res.status === "success"){
                                                                    const response = await fetchMessages(username);
                                                                    setMessages(response.data);
                                                                }
                                                                //alert(username);
                                                            }
                                                        }
                                                        className="block border border-gray-300 p-3 rounded hover:bg-gray-700 transition bg-blue-500 text-white text-center py-2 px-4"
                                                    >
                                                        Accept
                                                    </button> 
                                                    <button
                                                        onClick={ async () => { 
                                                                const res = await accept_or_reject_new_team_member(message.identifier, 1);
                                                                if(res.status === "success"){
                                                                    const response = await fetchMessages(username);
                                                                    setMessages(response.data);
                                                                }
                                                                //alert(username);
                                                            }
                                                        }
                                                        className="block border border-gray-300 p-3 rounded hover:bg-gray-700 transition bg-red-500 text-white text-center py-2 px-4"
                                                    >
                                                        Reject
                                                    </button> 
                                                </div>
                                                <div className={`${message.type === 2 ? '' : 'hidden'} flex items-center mb-2 ${message.username === username ? 'justify-start' : 'justify-end'}`}>
                                                    <button
                                                        onClick={ async () => { 
                                                                const res = await accept_or_reject_coach_invite(message.identifier, 0);
                                                                if(res.status === "success"){
                                                                    const response = await fetchMessages(username);
                                                                    setMessages(response.data);
                                                                }
                                                                //alert(username);
                                                            }
                                                        }
                                                        className="block border border-gray-300 p-3 rounded hover:bg-gray-700 transition bg-blue-500 text-white text-center py-2 px-4"
                                                    >
                                                        Accept
                                                    </button> 
                                                    <button
                                                        onClick={ async () => { 
                                                                const res = await accept_or_reject_coach_invite(message.identifier, 1);
                                                                if(res.status === "success"){
                                                                    const response = await fetchMessages(username);
                                                                    setMessages(response.data);
                                                                }
                                                                //alert(username);
                                                            }
                                                        }
                                                        className="block border border-gray-300 p-3 rounded hover:bg-gray-700 transition bg-red-500 text-white text-center py-2 px-4"
                                                    >
                                                        Reject
                                                    </button> 
                                                </div>
                                                <div className={`${message.type === 1  ? '' : 'hidden'} flex items-center mb-2 ${message.username === username ? 'justify-start' : 'justify-end'}`}>
                                                    <button
                                                        onClick={ async () => { 
                                                                const res = await clear_message(message.identifier, 0);
                                                                if(res.status === "success"){
                                                                    const response = await fetchMessages(username);
                                                                    setMessages(response.data);
                                                                    //alert("Refresh gone wrong.");
                                                                }
                                                                //alert(username);
                                                            }
                                                        }
                                                        className="block border border-gray-300 p-3 rounded hover:bg-gray-700 transition bg-blue-500 text-white text-center py-2 px-4"
                                                    >
                                                        Okay
                                                    </button>                   
                                                </div>
                                                <p className="text-sm text-gray-500">{new Date(message.timestamp).toLocaleString()}</p>
                                            </li>
                                        )
                                }else{ 
                                    return (
                                        <li 
                                            key={index} 
                                            className={`flex flex-col ${message.username === username ? 'items-start' : 'items-end'}`}
                                        >
                                            <div className="flex items-center mb-2">
                                                <FaUserCircle className="text-blue-500 text-2xl mr-2" />
                                                <span className="font-semibold">{message.sender}</span>
                                            </div>
                                            <div className={`flex items-center mb-2 ${message.username === username ? 'justify-start' : 'justify-end'}`}>
                                                <FaEnvelopeOpenText className="text-green-500 text-xl mr-2" />
                                                <span className="text-gray-700 bg-gray-200 p-2 rounded-lg max-w-xs break-words" dangerouslySetInnerHTML={{ __html: message.content.replace(/\n/g, '<br />') }}></span>
                                            </div>
                                            <p className="text-sm text-gray-500">{new Date(message.timestamp).toLocaleString()}</p>
                                        </li>)
                                }
                            })}
                            <div ref={messagesEndRef} />
                        </ul>
                    )}
                </div>
                <div className="bg-white p-4 shadow-md flex items-center">
                    <textarea
                        ref={textareaRef}
                        className="flex-grow p-2 border rounded-lg mr-2"
                        placeholder="Type a message..."
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        onKeyDown={handleKeyDown}
                        rows={2}
                    />
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded-lg"
                        onClick={handleSendMessage}
                    >
                        Send
                    </button>
                </div>
            </div>
            <CustomFooter />
        </div>
    );
};

export default ViewMessages;
